// Attempting to fetch the bounds of the map during movement, animation, or style loading results
// in an unhandled error being thrown by mapbox-gl. This utility wraps the getBounds method to
// ensure that this error is properly handled
export default function getBoundsSafely(
    map: mapboxgl.Map | undefined
): mapboxgl.LngLatBounds | undefined {
    if (!map) return undefined;

    let bounds: mapboxgl.LngLatBounds | undefined;
    try {
        bounds = map?.getBounds();
    } catch (e) {
        return bounds;
    }
    return bounds;
}
